import { AbstractCommand } from 'src/models/command';
type IdoButtonParameter = {
	idoWindow: {
		idoWindowIdoInstances: {
			aggregateId: string;
			aggregateVersion: number;
			idoWindowIdos: {
				aggregateId: string;
				aggregateVersion: number;
			}[];
		}[];
	};
};

class CreateANewTaskCommand extends AbstractCommand {
	readonly name = 'IFS_DesktopModule_Task_Command_Command_CreateANewTaskCommand';

	public constructor(authenticatedUserId: number, idoButton: IdoButtonParameter) {
		super();
		this.parameters = {
			activitylinkButton: {},
			alarmConfig: {},
			archivButton: {},
			changeable: false,
			content: '',
			favoriteButton: {},
			fixedMaturityDate: '',
			forerunTime: 0,
			globalizationButton: {
				globalizationTooltip: {},
				globalizationWindow: {},
			},
			idoButton: idoButton,
			inactive: true,
			lockConfig: {},
			moduleLayout: 'task',
			ownerUserId: 0,
			repetitionConfig: {},
			responsibleUserId: authenticatedUserId,
			statusButton: {},
			title: '',
		};
	}
}

export { CreateANewTaskCommand };
